module.exports = __webpack_public_path__ + "static/media/slider1-4.588d554a.png";